import script from "./import-offices-button.vue?vue&type=script&lang=js"
export * from "./import-offices-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__